module.exports = __webpack_public_path__ + "static/img/pj1-3.4e27235.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/pj1-3.png
// module id = 712
// module chunks = 0